"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateAPY = exports.SECONDS_IN_YEAR = void 0;
const ethers_1 = require("ethers");
const quickWeiValuePow_1 = require("./quickWeiValuePow");
exports.SECONDS_IN_YEAR = ethers_1.BigNumber.from(365 * 24 * 60 * 60);
function calculateAPY(distributedTokens, distributionDurationSecs, priceOfDistributedToken, stakedUsdValue) {
    if (stakedUsdValue.isZero()) {
        return ethers_1.constants.Zero;
    }
    const durationInMonths = Math.round((distributionDurationSecs.toNumber() / exports.SECONDS_IN_YEAR.toNumber()) * 12);
    const r = distributedTokens.mul(priceOfDistributedToken).div(stakedUsdValue);
    const N = ethers_1.BigNumber.from(12).div(durationInMonths);
    return (0, quickWeiValuePow_1.quickWeiValuePow)(ethers_1.constants.WeiPerEther.add(r), N).sub(ethers_1.constants.WeiPerEther);
}
exports.calculateAPY = calculateAPY;
//# sourceMappingURL=calculateAPY.js.map